import React from 'react';
import { MapPin, CheckCircle } from 'lucide-react';
import { locationsServed } from '../../data/mock';

const LocationsSection = () => {
  return (
    <section id="locations" className="bg-[#121212] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase mb-4">
            Service Areas
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            Proudly Serving All Major Florida Cities
          </h2>
          <p className="text-lg text-white/70 leading-relaxed">
            Our armed security officers are strategically positioned throughout Florida, 
            enabling rapid deployment to protect your assets wherever you need us.
          </p>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {locationsServed.map((city, index) => (
            <div
              key={index}
              className="group flex items-center gap-2 p-4 border border-white/10 hover:border-[#00FFD1]/30 bg-black transition-all duration-300"
            >
              <MapPin className="w-4 h-4 text-[#00FFD1] flex-shrink-0" />
              <span className="text-white/85 group-hover:text-white transition-colors">
                {city}
              </span>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 text-center">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-[#00FFD1]" />
            <span className="text-white/70">Statewide Coverage Available</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/20" />
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-[#00FFD1]" />
            <span className="text-white/70">24/7 Emergency Response</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/20" />
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-[#00FFD1]" />
            <span className="text-white/70">Rapid Deployment</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
